import {
  USER_SIGNIN,
  USER_SIGNOUT
} from '../type'

var isLoggedIn = function(str) {
  var user = JSON.parse(localStorage.getItem('user'))
  if (user) {
    return JSON.parse(localStorage.getItem('user'))[str]
  } else {
    return false
  }
}

const state = {
  loginstatus: isLoggedIn('status') || false,
  isVendor: isLoggedIn('isVendor') || 0,
  token: isLoggedIn('info') || null
}

// const getters = {
//	LoginToken:(state) => state.token,
//	LoginStatus:(state) => state.loginstatus
// }

// const actions = {
//	UserLogin({commit},data){
//		commit(USER_SIGNIN,data);
//		window.loaction = '/home';
//	},
//	UserLoginOut({commit},data){
//
//	}
// }

const mutations = {
  [USER_SIGNIN](state, user) {
    localStorage.setItem('user', JSON.stringify(user))
    state.loginstatus = user.status === '1'
    state.isVendor = +user.isVendor
    state.token = user.info
  },
  [USER_SIGNOUT](state, data) {
    localStorage.removeItem('user')
    state.loginstatus = false
    state.isVendor = 0
    state.token = null
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js